const { defineMessages } = require('@sm/intl');

const TYPE_HEADER = '[Type: Header][Vis: high] - Feature Set List Item Tooltip Heading';
const TYPE_PARAGRAPH = '[Type: Paragraph][Vis: high] - Feature Set List Item Tooltip';
const NUM_RESPONSES = 'NUMBER OF RESPONSES';
const NUM_RESPONSES_TOOLTIP =
  'Each plan has a limited number of responses as indicated. Basic users must purchase a paid plan to view responses in excess of the Response Limit. For other plans, users will be invoiced up to US$0.80 cent or equivalent, for each response over the indicated Response Limit.';
const SUPPORT = '24/7 CUSTOMER SUPPORT VIA EMAIL';
const SUPPORT_TOOLTIP =
  'We offer 24/7 email support for all customers. Emails from ADVANTAGE and PREMIER customers are prioritized to receive responses as quickly as possible. We also offer phone support for our PREMIER customers.';

export default defineMessages({
  '508_accessibility_tooltip_heading': {
    id: 'PricingSummary.Feature.508AccessibilityTooltipHeading',
    defaultMessage: 'ADA compliancy',
    desc: TYPE_HEADER,
  },
  '508_accessibility_tooltip': {
    id: 'PricingSummary.Feature.508AccessibilityTooltip',
    defaultMessage: 'ADA compliant tooltip',
    desc: TYPE_PARAGRAPH,
  },
  a_b_testing_tooltip_heading: {
    id: 'PricingSummary.Feature.ABTestingTooltipHeading',
    defaultMessage: 'A/B Testing Heading',
    desc: TYPE_HEADER,
  },
  a_b_testing_tooltip: {
    id: 'PricingSummary.Feature.ABTestingTooltip',
    defaultMessage: 'A/B Testing tooltip',
    desc: TYPE_PARAGRAPH,
  },
  account_verification_tooltip_heading: {
    id: 'PricingSummary.Feature.AccountVerificationTooltipHeading',
    defaultMessage: 'Account Verification Heading',
    desc: TYPE_HEADER,
  },
  account_verification_tooltip: {
    id: 'PricingSummary.Feature.AccountVerificationTooltip',
    defaultMessage: 'Account Verification tooltip',
    desc: TYPE_PARAGRAPH,
  },
  add_users_tooltip_heading: {
    id: 'PricingSummary.Feature.AddUsersTooltipHeading',
    defaultMessage: 'Add Users Heading',
    desc: TYPE_HEADER,
  },
  add_users_tooltip: {
    id: 'PricingSummary.Feature.AddUsersTooltip',
    defaultMessage: 'Add Users tooltip',
    desc: TYPE_PARAGRAPH,
  },
  admin_dashboard_tooltip_heading: {
    id: 'PricingSummary.Feature.AdminDashboardTooltipHeading',
    defaultMessage: 'Admin Dashboard Heading',
    desc: TYPE_HEADER,
  },
  admin_dashboard_tooltip: {
    id: 'PricingSummary.Feature.AdminDashboardTooltip',
    defaultMessage: 'Admin Dashboard tooltip',
    desc: TYPE_PARAGRAPH,
  },
  advanced_logic_tooltip_heading: {
    id: 'PricingSummary.Feature.AdvancedLogicTooltipHeading',
    defaultMessage: 'Advanced Logic Heading',
    desc: TYPE_HEADER,
  },
  advanced_logic_tooltip: {
    id: 'PricingSummary.Feature.AdvancedLogicTooltip',
    defaultMessage: 'Advanced Logic tooltip',
    desc: TYPE_PARAGRAPH,
  },
  advanced_survey_features_tooltip_heading: {
    id: 'PricingSummary.Feature.AdvancedSurveyFeaturesTooltipHeading',
    defaultMessage: 'Advanced Survey Features Heading',
    desc: TYPE_HEADER,
  },
  advanced_survey_features_tooltip: {
    id: 'PricingSummary.Feature.AdvancedSurveyFeaturesTooltip',
    defaultMessage: 'Advanced Survey Features tooltip',
    desc: TYPE_PARAGRAPH,
  },
  all_languages_supported_tooltip_heading: {
    id: 'PricingSummary.Feature.AllLanguagesSupportedTooltipHeading',
    defaultMessage: 'All Languages Supported Heading',
    desc: TYPE_HEADER,
  },
  all_languages_supported_tooltip: {
    id: 'PricingSummary.Feature.AllLanguagesSupportedTooltip',
    defaultMessage: 'All Languages Supported tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_access_benchmarking_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeAccessBenchmarkingTooltipHeading',
    defaultMessage: 'Analyze Access Benchmarking Heading',
    desc: TYPE_HEADER,
  },
  analyze_access_benchmarking_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeAccessBenchmarkingTooltip',
    defaultMessage: 'Analyze Access Benchmarking tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_customize_charts_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanCustomizeChartsTooltipHeading',
    defaultMessage: 'Analyze Custom Charts Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_customize_charts_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanCustomizeChartsTooltip',
    defaultMessage: 'Analyze Custom Charts tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_export_hide_branding_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanExportHideBrandingTooltipHeading',
    defaultMessage: 'Analyze Export Branding Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_export_hide_branding_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanExportHideBrandingTooltip',
    defaultMessage: 'Analyze Export Branding tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_export_ta_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanExportTATooltipHeading',
    defaultMessage: 'Analyze Export TA Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_export_ta_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanExportTATooltip',
    defaultMessage: 'Analyze Export TA tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_save_views_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanSaveViewsTooltipHeading',
    defaultMessage: 'Analyze Save Views Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_save_views_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanSaveViewsTooltip',
    defaultMessage: 'Analyze Save Views tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_share_customize_branding_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeBrandingTooltipHeading',
    defaultMessage: 'Analyze Share Customize Branding Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_share_customize_branding_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeBrandingTooltip',
    defaultMessage: 'Analyze Share Customize Branding tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_share_customize_domain_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeDomainTooltipHeading',
    defaultMessage: 'Analyze Share Customize Domain Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_share_customize_domain_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanShareCustomizeDomainTooltip',
    defaultMessage: 'Analyze Share Customize Domain tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_ta_search_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanTASearchTooltipHeading',
    defaultMessage: 'Analyze TA Search Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_ta_search_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanTASearchTooltip',
    defaultMessage: 'Analyze TA Search tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_can_ta_tag_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeCanTATagTooltipHeading',
    defaultMessage: 'Analyze TA Tag Heading',
    desc: TYPE_HEADER,
  },
  analyze_can_ta_tag_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeCanTATagTooltip',
    defaultMessage: 'Analyze TA Tag tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_combine_filters_tooltip_heading: {
    id: 'PricingSummary.Feature.CombineFiltersTooltipHeading',
    defaultMessage: 'Analyze Combine Filters Heading',
    desc: TYPE_HEADER,
  },
  analyze_combine_filters_tooltip: {
    id: 'PricingSummary.Feature.CombineFiltersTooltip',
    defaultMessage: 'Analyze Combine Filters tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_dashboard_password_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeDashboardPasswordEnabledTooltipHeading',
    defaultMessage: 'Analyze Dashboard Password Heading',
    desc: TYPE_HEADER,
  },
  analyze_dashboard_password_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeDashboardPasswordEnabledTooltip',
    defaultMessage: 'Analyze Dashboard Password tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_delete_respondent_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeDeleteRespondentLimitTooltipHeading',
    defaultMessage: 'Analyze Delete Respondent Limit Heading',
    desc: TYPE_HEADER,
  },
  analyze_delete_respondent_limit_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeDeleteRespondentLimitTooltip',
    defaultMessage: 'Analyze Delete Respondent Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_export_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeExportEnabledTooltipHeading',
    defaultMessage: 'DATA EXPORTS',
    desc: TYPE_HEADER,
  },
  analyze_export_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeExportEnabledTooltip',
    defaultMessage: `Easily create tests and assessments with automatic scoring for employees, customers, students, and more. You can choose whether you want to display your respondent's score to them after they complete your quiz. You'll also be able to see rankings, segment response data, and access statistics for your results.`,
    desc: TYPE_PARAGRAPH,
  },
  analyze_export_spss_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeExportSpssEnabledTooltipHeading',
    defaultMessage: 'ADVANCED DATA EXPORTS',
    desc: TYPE_HEADER,
  },
  analyze_export_spss_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeExportSpssEnabledTooltip',
    defaultMessage:
      'Download your survey results into SPSS-along with CSV, PDF, PPT, or XLS files too. Also create and print custom charts and reports quickly and easily.',
    desc: TYPE_PARAGRAPH,
  },
  analyze_integrations_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeIntegrationsTooltipHeading',
    defaultMessage: 'Analyze Integrations Heading',
    desc: TYPE_HEADER,
  },
  analyze_integrations_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeIntegrationsTooltip',
    defaultMessage: 'Analyze Integrations tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_password_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzePasswordEnabledTooltipHeading',
    defaultMessage: 'Analyze Password Enabled Heading',
    desc: TYPE_HEADER,
  },
  analyze_password_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzePasswordEnabledTooltip',
    defaultMessage: 'Analyze Password Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_response_delete_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeResponseDeleteLimitTooltipHeading',
    defaultMessage: 'Analyze Response Delete Limit Heading',
    desc: TYPE_HEADER,
  },
  analyze_response_delete_limit_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeResponseDeleteLimitTooltip',
    defaultMessage: 'Analyze Response Delete Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_response_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeResponseLimitTooltipHeading',
    defaultMessage: 'Analyze Response Limit Heading',
    desc: TYPE_HEADER,
  },
  analyze_response_limit_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeResponseLimitTooltip',
    defaultMessage: 'Analyze Response Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_results_together_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeResultsTogetherTooltipHeading',
    defaultMessage: 'Analyze Results Together Heading',
    desc: TYPE_HEADER,
  },
  analyze_results_together_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeResultsTogetherTooltip',
    defaultMessage: 'Analyze Results Together tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_rule_based_tagging_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeRuleBasedTaggingTooltipHeading',
    defaultMessage: 'Analyze Rule Based Tagging Heading',
    desc: TYPE_HEADER,
  },
  analyze_rule_based_tagging_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeRuleBasedTaggingTooltip',
    defaultMessage: 'Analyze Rule Based Tagging tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_rule_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeRuleLimitTooltipHeading',
    defaultMessage: 'Analyze Rule Limit Heading',
    desc: TYPE_HEADER,
  },
  analyze_rule_limit_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeRuleLimitTooltip',
    defaultMessage: 'Analyze Rule Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_sentiment_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeSentimentEnabledTooltipHeading',
    defaultMessage: 'Analyze Sentiment Enabled Heading',
    desc: TYPE_HEADER,
  },
  analyze_sentiment_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeSentimentEnabledTooltip',
    defaultMessage: 'Analyze Sentiment Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_shared_results_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeSharedResultsEnabledTooltipHeading',
    defaultMessage: 'Analyze Shared Results Enabled Heading',
    desc: TYPE_HEADER,
  },
  analyze_shared_results_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeSharedResultsEnabledTooltip',
    defaultMessage: 'Analyze Shared Results Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_ta_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeTAEnabledTooltipHeading',
    defaultMessage: 'Analyze TA Enabled Heading',
    desc: TYPE_HEADER,
  },
  analyze_ta_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeTAEnabledTooltip',
    defaultMessage: 'Analyze TA Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  analyze_trends_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.AnalyzeTrendsEnabledTooltipHeading',
    defaultMessage: 'Analyze Trends Enabled Heading',
    desc: TYPE_HEADER,
  },
  analyze_trends_enabled_tooltip: {
    id: 'PricingSummary.Feature.AnalyzeTrendsEnabledTooltip',
    defaultMessage: 'Analyze Trends Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  api_access_tooltip_heading: {
    id: 'PricingSummary.Feature.ApiAccessTooltipHeading',
    defaultMessage: 'API Access Heading',
    desc: TYPE_HEADER,
  },
  api_access_tooltip: {
    id: 'PricingSummary.Feature.ApiAccessTooltip',
    defaultMessage: 'API Access tooltip',
    desc: TYPE_PARAGRAPH,
  },
  asset_library_tooltip_heading: {
    id: 'PricingSummary.Feature.AssetLibraryTooltipHeading',
    defaultMessage: 'Asset Library Heading',
    desc: TYPE_HEADER,
  },
  asset_library_tooltip: {
    id: 'PricingSummary.Feature.AssetLibraryTooltip',
    defaultMessage: 'Asset Library tooltip',
    desc: TYPE_PARAGRAPH,
  },
  assign_admin_role_tooltip_heading: {
    id: 'PricingSummary.Feature.AssignAdminRoleTooltipHeading',
    defaultMessage: 'Assign Admin Role Heading',
    desc: TYPE_HEADER,
  },
  assign_admin_role_tooltip: {
    id: 'PricingSummary.Feature.AssignAdminRoleTooltip',
    defaultMessage: 'Assign Admin Role tooltip',
    desc: TYPE_PARAGRAPH,
  },
  base_response_count_tooltip_heading: {
    id: 'PricingSummary.Feature.BaseResponseCountTooltipHeading',
    defaultMessage: NUM_RESPONSES,
    desc: TYPE_HEADER,
  },
  base_response_count_tooltip: {
    id: 'PricingSummary.Feature.BaseResponseCountTooltip',
    defaultMessage: NUM_RESPONSES_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  benchmarks_tooltip_heading: {
    id: 'PricingSummary.Feature.BenchmarksTooltipHeading',
    defaultMessage: 'SURVEYMONKEY INDUSTRY BENCHMARKS',
    desc: TYPE_HEADER,
  },
  benchmarks_tooltip: {
    id: 'PricingSummary.Feature.BenchmarksTooltip',
    defaultMessage: `Compare your results against the Industry Benchmark to understand how you're doing in the context of your greater industry. See your results in context to see how you measure up against your peers.`,
    desc: TYPE_PARAGRAPH,
  },
  best_worst_qt_tooltip_heading: {
    id: 'PricingSummary.Feature.BestWorstQTTooltipHeading',
    defaultMessage: 'Best Worst QT Heading',
    desc: TYPE_HEADER,
  },
  best_worst_qt_tooltip: {
    id: 'PricingSummary.Feature.BestWorstQTTooltip',
    defaultMessage: 'Best Worst QT tooltip',
    desc: TYPE_PARAGRAPH,
  },
  build_surveys_together_tooltip_heading: {
    id: 'PricingSummary.Feature.BuildSurveysTogetherTooltipHeading',
    defaultMessage: 'Build Surveys Together Heading',
    desc: TYPE_HEADER,
  },
  build_surveys_together_tooltip: {
    id: 'PricingSummary.Feature.BuildSurveysTogetherTooltip',
    defaultMessage: 'Build Surveys Together tooltip',
    desc: TYPE_PARAGRAPH,
  },
  bulk_survey_share_tooltip_heading: {
    id: 'PricingSummary.Feature.BulkSurveyShareTooltipHeading',
    defaultMessage: 'Bulk Survey Share Heading',
    desc: TYPE_HEADER,
  },
  bulk_survey_share_tooltip: {
    id: 'PricingSummary.Feature.BulkSurveyShareTooltip',
    defaultMessage: 'Bulk Survey Share tooltip',
    desc: TYPE_PARAGRAPH,
  },
  bulk_survey_transfer_tooltip_heading: {
    id: 'PricingSummary.Feature.BulkSurveyTransferTooltipHeading',
    defaultMessage: 'Bulk Survey Transfer Heading',
    desc: TYPE_HEADER,
  },
  bulk_survey_transfer_tooltip: {
    id: 'PricingSummary.Feature.BulkSurveyTransferTooltip',
    defaultMessage: 'Bulk Survey Transfer tooltip',
    desc: TYPE_PARAGRAPH,
  },
  carry_forward_tooltip_heading: {
    id: 'PricingSummary.Feature.CarryForwardTooltipHeading',
    defaultMessage: 'Carry Forward Heading',
    desc: TYPE_HEADER,
  },
  carry_forward_tooltip: {
    id: 'PricingSummary.Feature.CarryForwardTooltip',
    defaultMessage: 'Carry Forward tooltip',
    desc: TYPE_PARAGRAPH,
  },
  click_map_qt_tooltip_heading: {
    id: 'PricingSummary.Feature.ClickMapQTTooltipHeading',
    defaultMessage: 'CLICK MAP DATA VISUALIZATION',
    desc: TYPE_HEADER,
  },
  click_map_qt_tooltip: {
    id: 'PricingSummary.Feature.ClickMapQTTooltip',
    defaultMessage: `Collect feedback on an image by tracking where and how many respondents click on it. When analyzing and presenting results, you'll be able to see each click represented by a corresponding dot, so it's clear which areas stand out to your audience.`,
    desc: TYPE_PARAGRAPH,
  },
  collaboration_tooltip_heading: {
    id: 'PricingSummary.Feature.CollaborationTooltipHeading',
    defaultMessage: 'Collaboration Heading',
    desc: TYPE_HEADER,
  },
  collaboration_tooltip: {
    id: 'PricingSummary.Feature.CollaborationTooltip',
    defaultMessage: 'Collaboration tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collect_contact_information_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectContactInformationTooltipHeading',
    defaultMessage: 'Collect Contact Information Heading',
    desc: TYPE_HEADER,
  },
  collect_contact_information_tooltip: {
    id: 'PricingSummary.Feature.CollectContactInformationTooltip',
    defaultMessage: 'Collect Contact Information tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collect_email_throttle_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectEmailThrottleLimitTooltipHeading',
    defaultMessage: 'Collect Email Throttle Limit Heading',
    desc: TYPE_HEADER,
  },
  collect_email_throttle_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectEmailThrottleLimitTooltip',
    defaultMessage: 'Collect Email Throttle Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collect_min_daily_messages_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectMinDailyMessagesLimitTooltipHeading',
    defaultMessage: 'Collect Min Daily Messages Limit Heading',
    desc: TYPE_HEADER,
  },
  collect_min_daily_messages_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectMinDailyMessagesLimitTooltip',
    defaultMessage: 'Collect Min Daily Messages Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collect_responses_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectResponsesTooltipHeading',
    defaultMessage: 'Collect Responses Heading',
    desc: TYPE_HEADER,
  },
  collect_responses_tooltip: {
    id: 'PricingSummary.Feature.CollectResponsesTooltip',
    defaultMessage: 'Collect Responses tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_completion_url_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorCompletionUrlEnabledTooltipHeading',
    defaultMessage: 'Collector Completion Url Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_completion_url_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorCompletionUrlEnabledTooltip',
    defaultMessage: 'Collector Completion Url Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_contact_list_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorContactListLimitTooltipHeading',
    defaultMessage: 'Collector Contact List Limit Heading',
    desc: TYPE_HEADER,
  },
  collector_contact_list_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectorContactListLimitTooltip',
    defaultMessage: 'Collector Contact List Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_create_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorCreateLimitTooltipHeading',
    defaultMessage: 'Collector Create Limit Heading',
    desc: TYPE_HEADER,
  },
  collector_create_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectorCreateLimitTooltip',
    defaultMessage: 'Collector Create Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_email_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorEmailLimitTooltipHeading',
    defaultMessage: 'Collector Email Limit Heading',
    desc: TYPE_HEADER,
  },
  collector_email_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectorEmailLimitTooltip',
    defaultMessage: 'Collector Email Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_email_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorEmailEnabledTooltipHeading',
    defaultMessage: 'Collector Email Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_email_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorEmailEnabledTooltip',
    defaultMessage: 'Collector Email Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_facebook_messenger_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorFacebookMessengerEnabledTooltipHeading',
    defaultMessage: 'Collector Facebook Messenger Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_facebook_messenger_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorFacebookMessengerEnabledTooltip',
    defaultMessage: 'Collector Facebook Messenger Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_manual_data_entry_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorManualDataEntryEnabledTooltipHeading',
    defaultMessage: 'Collector Manuanl Data Entry Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_manual_data_entry_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorManualDataEntryEnabledTooltip',
    defaultMessage: 'Collector Manuanl Data Entry Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_mobile_sdk_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorMobileSdkEnabledTooltipHeading',
    defaultMessage: 'Collector Mobile SDK Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_mobile_sdk_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorMobileSdkEnabledTooltip',
    defaultMessage: 'Collector Mobile SDK Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_offline_kiosk_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorOfflineKioskEnabledTooltipHeading',
    defaultMessage: 'Collector Offline Kiosk Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_offline_kiosk_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorOfflineKioskEnabledTooltip',
    defaultMessage: 'Collector Offline Kiosk Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_popup_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorPopupEnabledTooltipHeading',
    defaultMessage: 'Collector Popup Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_popup_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorPopupEnabledTooltip',
    defaultMessage: 'Collector Popup Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_friendly_url_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorFriendlyUrlEnabledTooltipHeading',
    defaultMessage: 'Collector Friendly Url Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_friendly_url_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorFriendlyUrlEnabledTooltip',
    defaultMessage: 'Collector Friendly Url Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_max_responses_delete_count_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorMaxResponsesDeleteCountTooltipHeading',
    defaultMessage: 'Collector Max Responses Delete Count Heading',
    desc: TYPE_HEADER,
  },
  collector_max_responses_delete_count_tooltip: {
    id: 'PricingSummary.Feature.CollectorMaxResponsesDeleteCountTooltip',
    defaultMessage: 'Collector Max Responses Delete Count tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_recipients_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorRecipientsLimitTooltipHeading',
    defaultMessage: 'Collector Recipients Limit Heading',
    desc: TYPE_HEADER,
  },
  collector_recipients_limit_tooltip: {
    id: 'PricingSummary.Feature.CollectorRecipientsLimitTooltip',
    defaultMessage: 'Collector Recipients Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_thank_you_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorThankYouEnabledTooltipHeading',
    defaultMessage: 'Collector Thank You Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_thank_you_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorThankYouEnabledTooltip',
    defaultMessage: 'Collector Thank You Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_white_label_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorWhiteLabelEnabledTooltipHeading',
    defaultMessage: 'Collector White Label Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_white_label_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorWhiteLabelEnabledTooltip',
    defaultMessage: 'Collector White Label Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collector_zoom_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorZoomEnabledTooltipHeading',
    defaultMessage: 'Collector Zoom Enabled Heading',
    desc: TYPE_HEADER,
  },
  collector_zoom_enabled_tooltip: {
    id: 'PricingSummary.Feature.CollectorZoomEnabledTooltip',
    defaultMessage: 'Collector Zoom Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collectors_read_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorsReadTooltipHeading',
    defaultMessage: 'Collectors Read Heading',
    desc: TYPE_HEADER,
  },
  collectors_read_tooltip: {
    id: 'PricingSummary.Feature.CollectorsReadTooltip',
    defaultMessage: 'Collectors Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collectors_write_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectorsWriteTooltipHeading',
    defaultMessage: 'Collectors Write Heading',
    desc: TYPE_HEADER,
  },
  collectors_write_tooltip: {
    id: 'PricingSummary.Feature.CollectorsWriteTooltip',
    defaultMessage: 'Collectors Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  collect_end_page_question_bank_demographics_tooltip_heading: {
    id: 'PricingSummary.Feature.CollectEndPageQuestionBankDemographicsTooltipHeading',
    defaultMessage: 'Collect End Page Question Bank Demographics Heading',
    desc: TYPE_HEADER,
  },
  collect_end_page_question_bank_demographics_tooltip: {
    id: 'PricingSummary.Feature.CollectEndPageQuestionBankDemographicsTooltip',
    defaultMessage: 'Collect End Page Question Bank Demographics tooltip',
    desc: TYPE_PARAGRAPH,
  },
  comment_box_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.CommentBoxQuestionTypeTooltipHeading',
    defaultMessage: 'Comment Box Question Type Heading',
    desc: TYPE_HEADER,
  },
  comment_box_question_type_tooltip: {
    id: 'PricingSummary.Feature.CommentBoxQuestionTypeTooltip',
    defaultMessage: 'Comment Box Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  consolidated_billing_tooltip_heading: {
    id: 'PricingSummary.Feature.ConsolidatedBillingTooltipHeading',
    defaultMessage: 'Consolidatd Billing Heading',
    desc: TYPE_HEADER,
  },
  consolidated_billing_tooltip: {
    id: 'PricingSummary.Feature.ConsolidatedBillingTooltip',
    defaultMessage: 'Consolidatd Billing tooltip',
    desc: TYPE_PARAGRAPH,
  },
  contacts_read_tooltip_heading: {
    id: 'PricingSummary.Feature.ContactsReadTooltipHeading',
    defaultMessage: 'Contacts Read Heading',
    desc: TYPE_HEADER,
  },
  contacts_read_tooltip: {
    id: 'PricingSummary.Feature.ContactsReadTooltip',
    defaultMessage: 'Contacts Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  contacts_write_tooltip_heading: {
    id: 'PricingSummary.Feature.ContactsWriteTooltipHeading',
    defaultMessage: 'Contacts Write Heading',
    desc: TYPE_HEADER,
  },
  contacts_write_tooltip: {
    id: 'PricingSummary.Feature.ContactsWriteTooltip',
    defaultMessage: 'Contacts Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_custom_chatbot_avatar_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateCustomChatbotAvatarTooltipHeading',
    defaultMessage: 'Create Custom Chatbot Avatar Heading',
    desc: TYPE_HEADER,
  },
  create_custom_chatbot_avatar_tooltip: {
    id: 'PricingSummary.Feature.CreateCustomChatbotAvatarTooltip',
    defaultMessage: 'Create Custom Chatbot Avatar tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_custom_html_email_message_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateCustomHtmlEmailMessageEnabledTooltipHeading',
    defaultMessage: 'Create Custom Html Email Message Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_custom_html_email_message_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateCustomHtmlEmailMessageEnabledTooltip',
    defaultMessage: 'Create Custom Html Email Message Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_custom_theme_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateCustomThemeEnabledTooltipHeading',
    defaultMessage: 'Create Custom Theme Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_custom_theme_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateCustomThemeEnabledTooltip',
    defaultMessage: 'Create Custom Theme Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_custom_variables_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateCustomVariablesEnabledTooltipHeading',
    defaultMessage: 'CUSTOM VARIABLES',
    desc: TYPE_HEADER,
  },
  create_custom_variables_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateCustomVariablesEnabledTooltip',
    defaultMessage:
      'Use custom variables to track data about respondents by passing one or more values through a survey link and into your survey results.',
    desc: TYPE_PARAGRAPH,
  },
  create_grayscale_footer_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateGrayscaleFooterTooltipHeading',
    defaultMessage: 'Create Grayscale Footer Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_grayscale_footer_tooltip: {
    id: 'PricingSummary.Feature.CreateGrayscaleFooterTooltip',
    defaultMessage: 'Create Grayscale Footer Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_logo_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateLogoEnabledTooltipHeading',
    defaultMessage: 'Create Logo Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_logo_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateLogoEnabledTooltip',
    defaultMessage: 'Create Logo Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_piping_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreatePipingEnabledTooltipHeading',
    defaultMessage: 'CUSTOMIZED SURVEY EXPERIENCE',
    desc: TYPE_HEADER,
  },
  create_piping_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreatePipingEnabledTooltip',
    defaultMessage: `Get more ways to personalize each respondent's experience while taking your survey. Use skip logic to create custom paths through a survey based on each respondent's answers. With question & answer piping, you can insert answer text from a question into another question on a later page in the survey.`,
    desc: TYPE_PARAGRAPH,
  },
  create_print_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreatePrintEnabledTooltipHeading',
    defaultMessage: 'Create Print Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_print_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreatePrintEnabledTooltip',
    defaultMessage: 'Create Print Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_question_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateQuestionLimitTooltipHeading',
    defaultMessage: 'QUESTIONS PER SURVEY',
    desc: TYPE_HEADER,
  },
  create_question_limit_tooltip: {
    id: 'PricingSummary.Feature.CreateQuestionLimitTooltip',
    defaultMessage:
      'Some of our plans only allow a certain number of questions for each survey you send. All plans allow you to create and send as many surveys as you want.',
    desc: TYPE_PARAGRAPH,
  },
  create_quotas_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateQuotasEnabledTooltipHeading',
    defaultMessage: 'Create Quotas Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_quotas_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateQuotasEnabledTooltip',
    defaultMessage: 'Create Quotas Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_random_assignment_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateRandomAssignmentEnabledTooltipHeading',
    defaultMessage: 'Create Random Assignment Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_random_assignment_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateRandomAssignmentEnabledTooltip',
    defaultMessage: 'Create Random Assignment Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_randomization_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateRandomizationEnabledTooltipHeading',
    defaultMessage: 'Create Randomization Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_randomization_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateRandomizationEnabledTooltip',
    defaultMessage: 'Create Randomization Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_skip_logic_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateSkipLogicEnabledTooltipHeading',
    defaultMessage: 'CUSTOMIZED SURVEY EXPERIENCE',
    desc: TYPE_HEADER,
  },
  create_skip_logic_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateSkipLogicEnabledTooltip',
    defaultMessage: `Get more ways to personalize each respondent's experience while taking your survey. Use skip logic to create custom paths through a survey based on each respondent's answers. With question & answer piping, you can insert answer text from a question into another question on a later page in the survey.`,
    desc: TYPE_PARAGRAPH,
  },
  create_templates_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateTemplatesEnabledTooltipHeading',
    defaultMessage: 'Create Templates Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_templates_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateTemplatesEnabledTooltip',
    defaultMessage: 'Create Templates Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  create_toggle_footer_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CreateToggleFooterEnabledTooltipHeading',
    defaultMessage: 'Create Toggle Footer Enabled Heading',
    desc: TYPE_HEADER,
  },
  create_toggle_footer_enabled_tooltip: {
    id: 'PricingSummary.Feature.CreateToggleFooterEnabledTooltip',
    defaultMessage: 'Create Toggle Footer Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  custom_charts_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomChartsTooltipHeading',
    defaultMessage: 'Custom Charts Heading',
    desc: TYPE_HEADER,
  },
  custom_charts_tooltip: {
    id: 'PricingSummary.Feature.CustomChartsTooltip',
    defaultMessage: 'Custom Charts tooltip',
    desc: TYPE_PARAGRAPH,
  },
  custom_templates_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomTemplatesTooltipHeading',
    defaultMessage: 'Custom Templates Heading',
    desc: TYPE_HEADER,
  },
  custom_templates_tooltip: {
    id: 'PricingSummary.Feature.CustomTemplatesTooltip',
    defaultMessage: 'Custom Templates tooltip',
    desc: TYPE_PARAGRAPH,
  },
  customize_disqualification_page_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.CustomizeDisqualificationPageEnabledTooltipHeading',
    defaultMessage: 'Customize Disqualification Page Enabled Heading',
    desc: TYPE_HEADER,
  },
  customize_disqualification_page_enabled_tooltip: {
    id: 'PricingSummary.Feature.CustomizeDisqualificationPageEnabledTooltip',
    defaultMessage: 'Customize Disqualification Page Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  data_ownership_tooltip_heading: {
    id: 'PricingSummary.Feature.DataOwnershipTooltipHeading',
    defaultMessage: 'Data Ownership Heading',
    desc: TYPE_HEADER,
  },
  data_ownership_tooltip: {
    id: 'PricingSummary.Feature.DataOwnershipTooltip',
    defaultMessage: 'Data Ownership tooltip',
    desc: TYPE_PARAGRAPH,
  },
  disable_closed_page_branding_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.DisableClosedPageBrandingEnbabledTooltipHeading',
    defaultMessage: 'Disable Closed Page Branding Enabled Heading',
    desc: TYPE_HEADER,
  },
  disable_closed_page_branding_enabled_tooltip: {
    id: 'PricingSummary.Feature.DisableClosedPageBrandingEnbabledTooltip',
    defaultMessage: 'Disable Closed Page Branding Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  disable_email_message_branding_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.DisableEmailMessageBrandingEnbabledTooltipHeading',
    defaultMessage: 'Disable Email Message Branding Enabled Heading',
    desc: TYPE_HEADER,
  },
  disable_email_message_branding_enabled_tooltip: {
    id: 'PricingSummary.Feature.DisableEmailMessageBrandingEnbabledTooltip',
    defaultMessage: 'Disable Email Message Branding Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  disable_footer_branding_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.DisableFooterBrandingEnbabledTooltipHeading',
    defaultMessage: 'Disable Footer Branding Enabled Heading',
    desc: TYPE_HEADER,
  },
  disable_footer_branding_enabled_tooltip: {
    id: 'PricingSummary.Feature.DisableFooterBrandingEnbabledTooltip',
    defaultMessage: 'Disable Footer Branding Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  download_as_csv_xls_pdf_tooltip_heading: {
    id: 'PricingSummary.Feature.DownloadAsCsvXlsPdfTooltipHeading',
    defaultMessage: 'Download as Csv/Xls/Pdf Heading',
    desc: TYPE_HEADER,
  },
  download_as_csv_xls_pdf_tooltip: {
    id: 'PricingSummary.Feature.DownloadAsCsvXlsPdfTooltip',
    defaultMessage: 'Download as Csv/Xls/Pdf tooltip',
    desc: TYPE_PARAGRAPH,
  },
  download_as_ppt_tooltip_heading: {
    id: 'PricingSummary.Feature.DownloadAsPptTooltipHeading',
    defaultMessage: 'Download as Ppt Heading',
    desc: TYPE_HEADER,
  },
  download_as_ppt_tooltip: {
    id: 'PricingSummary.Feature.DownloadAsPptTooltip',
    defaultMessage: 'Download as Ppt tooltip',
    desc: TYPE_PARAGRAPH,
  },
  email_support_tooltip_heading: {
    id: 'PricingSummary.Feature.EmailSupportTooltipHeading',
    defaultMessage: SUPPORT,
    desc: TYPE_HEADER,
  },
  email_support_tooltip: {
    id: 'PricingSummary.Feature.EmailSupportTooltip',
    defaultMessage: SUPPORT_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  email_tracking_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.EmailTrackingEnabledTooltipHeading',
    defaultMessage: 'Email Tracking Enabled Heading',
    desc: TYPE_HEADER,
  },
  email_tracking_enabled_tooltip: {
    id: 'PricingSummary.Feature.EmailTrackingEnabledTooltip',
    defaultMessage: 'Email Tracking Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  enable_ip_blocking_tooltip_heading: {
    id: 'PricingSummary.Feature.EnableIpBlockingTooltipHeading',
    defaultMessage: 'Enable Ip Blocking Heading',
    desc: TYPE_HEADER,
  },
  enable_ip_blocking_tooltip: {
    id: 'PricingSummary.Feature.EnableIpBlockingTooltip',
    defaultMessage: 'Enable Ip Blocking tooltip',
    desc: TYPE_PARAGRAPH,
  },
  essential_question_types_tooltip_heading: {
    id: 'PricingSummary.Feature.EssentialQuestionTypesTooltipHeading',
    defaultMessage: 'Essential Question Types Heading',
    desc: TYPE_HEADER,
  },
  essential_question_types_tooltip: {
    id: 'PricingSummary.Feature.EssentialQuestionTypesTooltip',
    defaultMessage: 'Essential Question Types tooltip',
    desc: TYPE_PARAGRAPH,
  },
  extended_piping_tooltip_heading: {
    id: 'PricingSummary.Feature.ExtendedPipingTooltipHeading',
    defaultMessage: 'Extended Piping Heading',
    desc: TYPE_HEADER,
  },
  extended_piping_tooltip: {
    id: 'PricingSummary.Feature.ExtendedPipingTooltip',
    defaultMessage: 'Extended Piping tooltip',
    desc: TYPE_PARAGRAPH,
  },
  extract_data_tooltip_heading: {
    id: 'PricingSummary.Feature.ExtractDataTooltipHeading',
    defaultMessage: 'Extract Data Heading',
    desc: TYPE_HEADER,
  },
  extract_data_tooltip: {
    id: 'PricingSummary.Feature.ExtractDataTooltip',
    defaultMessage: 'Extract Data tooltip',
    desc: TYPE_PARAGRAPH,
  },
  file_upload_tooltip_heading: {
    id: 'PricingSummary.Feature.FileUploadTooltipHeading',
    defaultMessage: 'FILE UPLOAD',
    desc: TYPE_HEADER,
  },
  file_upload_tooltip: {
    id: 'PricingSummary.Feature.FileUploadTooltip',
    defaultMessage:
      'Allow respondents to upload a file as part of their survey response. You can add up to 20 file upload questions per survey.',
    desc: TYPE_PARAGRAPH,
  },
  filter_crosstab_tooltip_heading: {
    id: 'PricingSummary.Feature.FilterCrosstabTooltipHeading',
    defaultMessage: 'Filter Crosstab Heading',
    desc: TYPE_HEADER,
  },
  filter_crosstab_tooltip: {
    id: 'PricingSummary.Feature.FilterCrosstabTooltip',
    defaultMessage: 'Filter Crosstab tooltip',
    desc: TYPE_PARAGRAPH,
  },
  funneling_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.FunnelingEnabledTooltipHeading',
    defaultMessage: 'Funneling Enabled Heading',
    desc: TYPE_HEADER,
  },
  funneling_enabled_tooltip: {
    id: 'PricingSummary.Feature.FunnelingEnabledTooltip',
    defaultMessage: 'Funneling Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  gold_features_included_tooltip_heading: {
    id: 'PricingSummary.Feature.GoldFeaturesIncludedTooltipHeading',
    defaultMessage: 'Gold Features Included Heading',
    desc: TYPE_HEADER,
  },
  gold_features_included_tooltip: {
    id: 'PricingSummary.Feature.GoldFeaturesIncludedTooltip',
    defaultMessage: 'Gold Features Included tooltip',
    desc: TYPE_PARAGRAPH,
  },
  group_contacts_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.GroupContactsLimitTooltipHeading',
    defaultMessage: 'Group Contacts Limit Heading',
    desc: TYPE_HEADER,
  },
  group_contacts_limit_tooltip: {
    id: 'PricingSummary.Feature.GroupContactsLimitTooltip',
    defaultMessage: 'Group Contacts Limit tooltip',
    desc: TYPE_PARAGRAPH,
  },
  group_templates_tooltip_heading: {
    id: 'PricingSummary.Feature.GroupTemplatesTooltipHeading',
    defaultMessage: 'Group Templates Heading',
    desc: TYPE_HEADER,
  },
  group_templates_tooltip: {
    id: 'PricingSummary.Feature.GroupTemplatesTooltip',
    defaultMessage: 'Group Templates tooltip',
    desc: TYPE_PARAGRAPH,
  },
  groups_read_tooltip_heading: {
    id: 'PricingSummary.Feature.GroupsReadTooltipHeading',
    defaultMessage: 'Groups Read Heading',
    desc: TYPE_HEADER,
  },
  groups_read_tooltip: {
    id: 'PricingSummary.Feature.GroupsReadTooltip',
    defaultMessage: 'Groups Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  groups_write_tooltip_heading: {
    id: 'PricingSummary.Feature.GroupsWriteTooltipHeading',
    defaultMessage: 'Groups Write Heading',
    desc: TYPE_HEADER,
  },
  groups_write_tooltip: {
    id: 'PricingSummary.Feature.GroupsWriteTooltip',
    defaultMessage: 'Groups Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  hide_export_branding_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.HideExportBrandingEnabledTooltipHeading',
    defaultMessage: 'Hide Export Branding Enabled Heading',
    desc: TYPE_HEADER,
  },
  hide_export_branding_enabled_tooltip: {
    id: 'PricingSummary.Feature.HideExportBrandingEnabledTooltip',
    defaultMessage: 'Hide Export Branding Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  hipaa_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.HipaaEnabledTooltipHeading',
    defaultMessage: 'Hipaa Enabled Heading',
    desc: TYPE_HEADER,
  },
  hipaa_enabled_tooltip: {
    id: 'PricingSummary.Feature.HipaaEnabledTooltip',
    defaultMessage: 'Hipaa Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  kiosk_mode_inactivity_timer_tooltip_heading: {
    id: 'PricingSummary.Feature.KioskModeInactivityTimerTooltipHeading',
    defaultMessage: 'Kiosk Mode Inactivity Timer Heading',
    desc: TYPE_HEADER,
  },
  kiosk_mode_inactivity_timer_tooltip: {
    id: 'PricingSummary.Feature.KioskModeInactivityTimerTooltip',
    defaultMessage: 'Kiosk Mode Inactivity Timer tooltip',
    desc: TYPE_PARAGRAPH,
  },
  kiosk_mode_passcode_lock_tooltip_heading: {
    id: 'PricingSummary.Feature.KioskModePasscodeLockTooltipHeading',
    defaultMessage: 'Kiosk Mode Passcode Lock Heading',
    desc: TYPE_HEADER,
  },
  kiosk_mode_passcode_lock_tooltip: {
    id: 'PricingSummary.Feature.KioskModePasscodeLockTooltip',
    defaultMessage: 'Kiosk Mode Passcode Lock tooltip',
    desc: TYPE_PARAGRAPH,
  },
  labeling_titles_numbering_tooltip_heading: {
    id: 'PricingSummary.Feature.LabelingTitlesNumberingTooltipHeading',
    defaultMessage: 'Labeling Titles Numbering Heading',
    desc: TYPE_HEADER,
  },
  labeling_titles_numbering_tooltip: {
    id: 'PricingSummary.Feature.LabelingTitlesNumberingTooltip',
    defaultMessage: 'Labeling Titles Numbering tooltip',
    desc: TYPE_PARAGRAPH,
  },
  library_read_tooltip_heading: {
    id: 'PricingSummary.Feature.LibraryReadTooltipHeading',
    defaultMessage: 'Library Read Heading',
    desc: TYPE_HEADER,
  },
  library_read_tooltip: {
    id: 'PricingSummary.Feature.LibraryReadTooltip',
    defaultMessage: 'Library Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  lite_library_tooltip_heading: {
    id: 'PricingSummary.Feature.LiteLibraryTooltipHeading',
    defaultMessage: 'Lite Library Heading',
    desc: TYPE_HEADER,
  },
  lite_library_tooltip: {
    id: 'PricingSummary.Feature.LiteLibraryTooltip',
    defaultMessage: 'Lite Library tooltip',
    desc: TYPE_PARAGRAPH,
  },
  max_collectors_per_survey_tooltip_heading: {
    id: 'PricingSummary.Feature.MaxCollectorsPerSurveyTooltipHeading',
    defaultMessage: 'Max Collectors Per Survey Heading',
    desc: TYPE_HEADER,
  },
  max_collectors_per_survey_tooltip: {
    id: 'PricingSummary.Feature.MaxCollectorsPerSurveyTooltip',
    defaultMessage: 'Max Collectors Per Survey tooltip',
    desc: TYPE_PARAGRAPH,
  },
  matrix_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.MatrixQuestionTypeTooltipHeading',
    defaultMessage: 'Matrix Question Type Heading',
    desc: TYPE_HEADER,
  },
  matrix_question_type_tooltip: {
    id: 'PricingSummary.Feature.MatrixQuestionTypeTooltip',
    defaultMessage: 'Matrix Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  maximum_daily_messages_tooltip_heading: {
    id: 'PricingSummary.Feature.MaximumDailyMessagesTooltipHeading',
    defaultMessage: 'Maximum Daily Message Heading',
    desc: TYPE_HEADER,
  },
  maximum_daily_messages_tooltip: {
    id: 'PricingSummary.Feature.MaximumDailyMessagesTooltip',
    defaultMessage: 'Maximum Daily Message tooltip',
    desc: TYPE_PARAGRAPH,
  },
  menu_matrix_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.MenuMatrixEnabledTooltipHeading',
    defaultMessage: 'Menu Matrix Enabled Heading',
    desc: TYPE_HEADER,
  },
  menu_matrix_enabled_tooltip: {
    id: 'PricingSummary.Feature.MenuMatrixEnabledTooltip',
    defaultMessage: 'Menu Matrix Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  metadata_settings_tooltip_heading: {
    id: 'PricingSummary.Feature.MetadataSettingsTooltipHeading',
    defaultMessage: 'Metadata Settings Heading',
    desc: TYPE_HEADER,
  },
  metadata_settings_tooltip: {
    id: 'PricingSummary.Feature.MetadataSettingsTooltip',
    defaultMessage: 'Metadata Settings tooltip',
    desc: TYPE_PARAGRAPH,
  },
  mobile_sdk_pull_response_data_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.MobileSdkPullResponseDataEnabledTooltipHeading',
    defaultMessage: 'Mobile Sdk Pull Response Data Heading',
    desc: TYPE_HEADER,
  },
  mobile_sdk_pull_response_data_enabled_tooltip: {
    id: 'PricingSummary.Feature.MobileSdkPullResponseDataEnabledTooltip',
    defaultMessage: 'Mobile Sdk Pull Response Data tooltip',
    desc: TYPE_PARAGRAPH,
  },
  mta_sparkpost_low_risk_ip_pools_tooltip_heading: {
    id: 'PricingSummary.Feature.MtaSparkpostLowRiskIpPoolsTooltipHeading',
    defaultMessage: 'MTA Sparkpost Low Risk Ip Pools Heading',
    desc: TYPE_HEADER,
  },
  mta_sparkpost_low_risk_ip_pools_tooltip: {
    id: 'PricingSummary.Feature.MtaSparkpostLowRiskIpPoolsTooltip',
    defaultMessage: 'MTA Sparkpost Low Risk Ip Pools tooltip',
    desc: TYPE_PARAGRAPH,
  },
  multilingual_tooltip_heading: {
    id: 'PricingSummary.Feature.MultilingualTooltipHeading',
    defaultMessage: 'Multilingual Heading',
    desc: TYPE_HEADER,
  },
  multilingual_tooltip: {
    id: 'PricingSummary.Feature.MultilingualTooltip',
    defaultMessage: 'Multilingual tooltip',
    desc: TYPE_PARAGRAPH,
  },
  multiple_block_rotation_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.MultipleBlockRotationEnabledTooltipHeading',
    defaultMessage: 'Multiple Block Rotation Enabled Heading',
    desc: TYPE_HEADER,
  },
  multiple_block_rotation_enabled_tooltip: {
    id: 'PricingSummary.Feature.MultipleBlockRotationEnabledTooltip',
    defaultMessage: 'Multiple Block Rotation Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  multiple_users_tooltip_heading: {
    id: 'PricingSummary.Feature.MultipleUsersTooltipHeading',
    defaultMessage: 'Multiple Users Heading',
    desc: TYPE_HEADER,
  },
  multiple_users_tooltip: {
    id: 'PricingSummary.Feature.MultipleUsersTooltip',
    defaultMessage: 'Multiple Users tooltip',
    desc: TYPE_PARAGRAPH,
  },
  new_stock_themes_tooltip_heading: {
    id: 'PricingSummary.Feature.NewStockThemesTooltipHeading',
    defaultMessage: 'New Stock Themes Heading',
    desc: TYPE_HEADER,
  },
  new_stock_themes_tooltip: {
    id: 'PricingSummary.Feature.NewStockThemesTooltip',
    defaultMessage: 'New Stock Themes tooltip',
    desc: TYPE_PARAGRAPH,
  },
  notification_center_tooltip_heading: {
    id: 'PricingSummary.Feature.NotificationCenterTooltipHeading',
    defaultMessage: 'Notification Center Heading',
    desc: TYPE_HEADER,
  },
  notification_center_tooltip: {
    id: 'PricingSummary.Feature.NotificationCenterTooltip',
    defaultMessage: 'Notification Center tooltip',
    desc: TYPE_PARAGRAPH,
  },
  num_free_responses_tooltip_heading: {
    id: 'PricingSummary.Feature.NumFreeResponsesTooltipHeading',
    defaultMessage: NUM_RESPONSES,
    desc: TYPE_HEADER,
  },
  num_free_responses_tooltip: {
    id: 'PricingSummary.Feature.NumFreeResponsesTooltip',
    defaultMessage: NUM_RESPONSES_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  onboarding_tooltip_heading: {
    id: 'PricingSummary.Feature.OnboardingTooltipHeading',
    defaultMessage: 'Onboarding Heading',
    desc: TYPE_HEADER,
  },
  onboarding_tooltip: {
    id: 'PricingSummary.Feature.OnboardingTooltip',
    defaultMessage: 'Onboarding tooltip',
    desc: TYPE_PARAGRAPH,
  },
  pagination_tooltip_heading: {
    id: 'PricingSummary.Feature.PaginationTooltipHeading',
    defaultMessage: 'Pagination Heading',
    desc: TYPE_HEADER,
  },
  pagination_tooltip: {
    id: 'PricingSummary.Feature.PaginationTooltip',
    defaultMessage: 'Pagination tooltip',
    desc: TYPE_PARAGRAPH,
  },
  paid_to_group_rollout_tooltip_heading: {
    id: 'PricingSummary.Feature.PaidToGroupRolloutTooltipHeading',
    defaultMessage: 'Paid To Group Rollout Heading',
    desc: TYPE_HEADER,
  },
  paid_to_group_rollout_tooltip: {
    id: 'PricingSummary.Feature.PaidToGroupRolloutTooltip',
    defaultMessage: 'Paid To Group Rollout tooltip',
    desc: TYPE_PARAGRAPH,
  },
  papi_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.PapiEnabledTooltipHeading',
    defaultMessage: 'Papi Enabled Heading',
    desc: TYPE_HEADER,
  },
  papi_enabled_tooltip: {
    id: 'PricingSummary.Feature.PapiEnabledTooltip',
    defaultMessage: 'Papi Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  password_protection_tooltip_heading: {
    id: 'PricingSummary.Feature.PasswordProtectionTooltipHeading',
    defaultMessage: 'Password Protection Heading',
    desc: TYPE_HEADER,
  },
  password_protection_tooltip: {
    id: 'PricingSummary.Feature.PasswordProtectionTooltip',
    defaultMessage: 'Password Protection tooltip',
    desc: TYPE_PARAGRAPH,
  },
  payment_qt_tooltip_heading: {
    id: 'PricingSummary.Feature.PaymentQTTooltipHeading',
    defaultMessage: 'ACCEPT PAYMENTS',
    desc: TYPE_HEADER,
  },
  payment_qt_tooltip: {
    id: 'PricingSummary.Feature.PaymentQTTooltip',
    defaultMessage:
      'Add a payment page to the end of your survey and accept payments through Stripe. Respondents can complete a survey and make a credit card payment at one time and in one place.',
    desc: TYPE_PARAGRAPH,
  },
  phone_support_tooltip_heading: {
    id: 'PricingSummary.Feature.PhoneSupportTooltipHeading',
    defaultMessage: SUPPORT,
    desc: TYPE_HEADER,
  },
  phone_support_tooltip: {
    id: 'PricingSummary.Feature.PhoneSupportTooltip',
    defaultMessage: SUPPORT_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  plans_benchmarks_tooltip_heading: {
    id: 'PricingSummary.Feature.PlansBenchmarkTooltipHeading',
    defaultMessage: 'Plans Benchmark Heading',
    desc: TYPE_HEADER,
  },
  plans_benchmarks_tooltip: {
    id: 'PricingSummary.Feature.PlansBenchmarkTooltip',
    defaultMessage: 'Plans Benchmark tooltip',
    desc: TYPE_PARAGRAPH,
  },
  pop_up_collector_tooltip_heading: {
    id: 'PricingSummary.Feature.PopupCollectorTooltipHeading',
    defaultMessage: 'Popup Collector Heading',
    desc: TYPE_HEADER,
  },
  pop_up_collector_tooltip: {
    id: 'PricingSummary.Feature.PopupCollectorTooltip',
    defaultMessage: 'Popup Collector tooltip',
    desc: TYPE_PARAGRAPH,
  },
  premium_themes_tooltip_heading: {
    id: 'PricingSummary.Feature.PremiumThemesTooltipHeading',
    defaultMessage: 'Premium Themes Heading',
    desc: TYPE_HEADER,
  },
  premium_themes_tooltip: {
    id: 'PricingSummary.Feature.PremiumThemesTooltip',
    defaultMessage: 'Premium Themes tooltip',
    desc: TYPE_PARAGRAPH,
  },
  priority_email_support_tooltip_heading: {
    id: 'PricingSummary.Feature.PrimaryEmailSupportTooltipHeading',
    defaultMessage: SUPPORT,
    desc: TYPE_HEADER,
  },
  priority_email_support_tooltip: {
    id: 'PricingSummary.Feature.PrimaryEmailSupportTooltip',
    defaultMessage: SUPPORT_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  private_apps_tooltip_heading: {
    id: 'PricingSummary.Feature.PrivateAppsTooltipHeading',
    defaultMessage: 'Private Apps Heading',
    desc: TYPE_HEADER,
  },
  private_apps_tooltip: {
    id: 'PricingSummary.Feature.PrivateAppsTooltip',
    defaultMessage: 'Private Apps tooltip',
    desc: TYPE_PARAGRAPH,
  },
  progress_bar_tooltip_heading: {
    id: 'PricingSummary.Feature.ProgressBarTooltipHeading',
    defaultMessage: 'Progress Bar Heading',
    desc: TYPE_HEADER,
  },
  progress_bar_tooltip: {
    id: 'PricingSummary.Feature.ProgressBarTooltip',
    defaultMessage: 'Progress Bar tooltip',
    desc: TYPE_PARAGRAPH,
  },
  question_library_tooltip_heading: {
    id: 'PricingSummary.Feature.QuestionLibraryTooltipHeading',
    defaultMessage: 'Question Library Heading',
    desc: TYPE_HEADER,
  },
  question_library_tooltip: {
    id: 'PricingSummary.Feature.QuestionLibraryTooltip',
    defaultMessage: 'Question Library tooltip',
    desc: TYPE_PARAGRAPH,
  },
  question_library_intl_tooltip_heading: {
    id: 'PricingSummary.Feature.QuestionLibraryIntlTooltipHeading',
    defaultMessage: 'Question Library Intl Heading',
    desc: TYPE_HEADER,
  },
  question_library_intl_tooltip: {
    id: 'PricingSummary.Feature.QuestionLibraryIntlTooltip',
    defaultMessage: 'Question Library Intl tooltip',
    desc: TYPE_PARAGRAPH,
  },
  quizzes_pro_tooltip_heading: {
    id: 'PricingSummary.Feature.QuizzesProTooltipHeading',
    defaultMessage: 'QUIZZES',
    desc: TYPE_HEADER,
  },
  quizzes_pro_tooltip: {
    id: 'PricingSummary.Feature.QuizzesProTooltip',
    defaultMessage: `Easily create tests and assessments with automatic scoring for employees, customers, students, and more. You can choose whether you want to display your respondent's score to them after they complete your quiz. You'll also be able to see rankings, segment response data, and access statistics for your results.`,
    desc: TYPE_PARAGRAPH,
  },
  randomize_answer_choices_tooltip_heading: {
    id: 'PricingSummary.Feature.RandomizeAnswerChoicesTooltipHeading',
    defaultMessage: 'Randomize Answer Choices Heading',
    desc: TYPE_HEADER,
  },
  randomize_answer_choices_tooltip: {
    id: 'PricingSummary.Feature.RandomizeAnswerChoicesTooltip',
    defaultMessage: 'Randomize Answer Choices tooltip',
    desc: TYPE_PARAGRAPH,
  },
  ranking_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.RankingQuestionTypeTooltipHeading',
    defaultMessage: 'Ranking Question Type Heading',
    desc: TYPE_HEADER,
  },
  ranking_question_type_tooltip: {
    id: 'PricingSummary.Feature.RankingQuestionTypeTooltip',
    defaultMessage: 'Ranking Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  rating_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.RatingQuestionTypeTooltipHeading',
    defaultMessage: 'Rating Question Type Heading',
    desc: TYPE_HEADER,
  },
  rating_question_type_tooltip: {
    id: 'PricingSummary.Feature.RatingQuestionTypeTooltip',
    defaultMessage: 'Rating Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  real_time_results_tooltip_heading: {
    id: 'PricingSummary.Feature.RealTimeResultsTooltipHeading',
    defaultMessage: 'Real Time Results Heading',
    desc: TYPE_HEADER,
  },
  real_time_results_tooltip: {
    id: 'PricingSummary.Feature.RealTimeResultsTooltip',
    defaultMessage: 'Real Time Results tooltip',
    desc: TYPE_PARAGRAPH,
  },
  receive_transferred_survey_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.ReceiveTransferredSurveyEnabledTooltipHeading',
    defaultMessage: 'Receive Transferred Survey Enabled Heading',
    desc: TYPE_HEADER,
  },
  receive_transferred_survey_enabled_tooltip: {
    id: 'PricingSummary.Feature.ReceiveTransferredSurveyEnabledTooltip',
    defaultMessage: 'Receive Transferred Survey Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  record_respondent_email_address_tooltip_heading: {
    id: 'PricingSummary.Feature.RecordRespondentEmailAddressTooltipHeading',
    defaultMessage: 'Record Respondent Email Address Heading',
    desc: TYPE_HEADER,
  },
  record_respondent_email_address_tooltip: {
    id: 'PricingSummary.Feature.RecordRespondentEmailAddressTooltip',
    defaultMessage: 'Record Respondent Email Address tooltip',
    desc: TYPE_PARAGRAPH,
  },
  recurring_email_collector_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.RecurringEmailCollectorEnabledTooltipHeading',
    defaultMessage: 'Recurring Email Collector Enabled Heading',
    desc: TYPE_HEADER,
  },
  recurring_email_collector_enabled_tooltip: {
    id: 'PricingSummary.Feature.RecurringEmailCollectorEnabledTooltip',
    defaultMessage: 'Recurring Email Collector Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  recurring_surveys_tooltip_heading: {
    id: 'PricingSummary.Feature.RecurringSurveysTooltipHeading',
    defaultMessage: 'Recurring Surveys Heading',
    desc: TYPE_HEADER,
  },
  recurring_surveys_tooltip: {
    id: 'PricingSummary.Feature.RecurringSurveysTooltip',
    defaultMessage: 'Recurring Surveys tooltip',
    desc: TYPE_PARAGRAPH,
  },
  require_answer_tooltip_heading: {
    id: 'PricingSummary.Feature.RequireAnswerTooltipHeading',
    defaultMessage: 'Require Answeer Heading',
    desc: TYPE_HEADER,
  },
  require_answer_tooltip: {
    id: 'PricingSummary.Feature.RequireAnswerTooltip',
    defaultMessage: 'Require Answeer tooltip',
    desc: TYPE_PARAGRAPH,
  },
  reshare_tooltip_heading: {
    id: 'PricingSummary.Feature.ReshareTooltipHeading',
    defaultMessage: 'Reshare Heading',
    desc: TYPE_HEADER,
  },
  reshare_tooltip: {
    id: 'PricingSummary.Feature.ReshareTooltip',
    defaultMessage: 'Reshare tooltip',
    desc: TYPE_PARAGRAPH,
  },
  respondent_receipt_tooltip_heading: {
    id: 'PricingSummary.Feature.RespondentReceiptTooltipHeading',
    defaultMessage: 'Respondent Receipt Heading',
    desc: TYPE_HEADER,
  },
  respondent_receipt_tooltip: {
    id: 'PricingSummary.Feature.RespondentReceiptTooltip',
    defaultMessage: 'Respondent Receipt tooltip',
    desc: TYPE_PARAGRAPH,
  },
  response_quality_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponseQualityEnabledTooltipHeading',
    defaultMessage: 'Response Quality Enabled Heading',
    desc: TYPE_HEADER,
  },
  response_quality_enabled_tooltip: {
    id: 'PricingSummary.Feature.ResponseQualityEnabledTooltip',
    defaultMessage: 'Response Quality Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  responses_read_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponsesReadTooltipHeading',
    defaultMessage: 'Responses Read Heading',
    desc: TYPE_HEADER,
  },
  responses_read_tooltip: {
    id: 'PricingSummary.Feature.ResponsesReadTooltip',
    defaultMessage: 'Responses Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  responses_read_detail_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponsesReadDetailTooltipHeading',
    defaultMessage: 'Responses Read Detail Heading',
    desc: TYPE_HEADER,
  },
  responses_read_detail_tooltip: {
    id: 'PricingSummary.Feature.ResponsesReadDetailTooltip',
    defaultMessage: 'Responses Read Detail tooltip',
    desc: TYPE_PARAGRAPH,
  },
  responses_write_tooltip_heading: {
    id: 'PricingSummary.Feature.ResponsesWriteTooltipHeading',
    defaultMessage: 'Responses Write Heading',
    desc: TYPE_HEADER,
  },
  responses_write_tooltip: {
    id: 'PricingSummary.Feature.ResponsesWriteTooltip',
    defaultMessage: 'Responses Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  roles_read_tooltip_heading: {
    id: 'PricingSummary.Feature.RolesReadTooltipHeading',
    defaultMessage: 'Roles Read Heading',
    desc: TYPE_HEADER,
  },
  roles_read_tooltip: {
    id: 'PricingSummary.Feature.RolesReadTooltip',
    defaultMessage: 'Roles Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  roles_write_tooltip_heading: {
    id: 'PricingSummary.Feature.RolesWriteTooltipHeading',
    defaultMessage: 'Roles Write Heading',
    desc: TYPE_HEADER,
  },
  roles_write_tooltip: {
    id: 'PricingSummary.Feature.RolesWriteTooltip',
    defaultMessage: 'Roles Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  sa_en_ga_tooltip_heading: {
    id: 'PricingSummary.Feature.SaEnGaTooltipHeading',
    defaultMessage: 'SA EN GA Heading',
    desc: TYPE_HEADER,
  },
  sa_en_ga_tooltip: {
    id: 'PricingSummary.Feature.SaEnGaTooltip',
    defaultMessage: 'SA EN GA tooltip',
    desc: TYPE_PARAGRAPH,
  },
  select_features_included_tooltip_heading: {
    id: 'PricingSummary.Feature.SelectFeaturesIncludedTooltipHeading',
    defaultMessage: 'Select Features Included Heading',
    desc: TYPE_HEADER,
  },
  select_features_included_tooltip: {
    id: 'PricingSummary.Feature.SelectFeaturesIncludedTooltip',
    defaultMessage: 'Select Features Included tooltip',
    desc: TYPE_PARAGRAPH,
  },
  send_surveys_tooltip_heading: {
    id: 'PricingSummary.Feature.SendSurveysTooltipHeading',
    defaultMessage: 'Send Surveys Heading',
    desc: TYPE_HEADER,
  },
  send_surveys_tooltip: {
    id: 'PricingSummary.Feature.SendSurveysTooltip',
    defaultMessage: 'Send Surveys tooltip',
    desc: TYPE_PARAGRAPH,
  },
  set_max_response_count_tooltip_heading: {
    id: 'PricingSummary.Feature.SetMaxResponseCountTooltipHeading',
    defaultMessage: 'Set Max Response Count Heading',
    desc: TYPE_HEADER,
  },
  set_max_response_count_tooltip: {
    id: 'PricingSummary.Feature.SetMaxResponseCountTooltip',
    defaultMessage: 'Set Max Response Count tooltip',
    desc: TYPE_PARAGRAPH,
  },
  set_survey_end_date_tooltip_heading: {
    id: 'PricingSummary.Feature.SetSurveyEndDateTooltipHeading',
    defaultMessage: 'Set Survey End Date Heading',
    desc: TYPE_HEADER,
  },
  set_survey_end_date_tooltip: {
    id: 'PricingSummary.Feature.SetSurveyEndDateTooltip',
    defaultMessage: 'Set Survey End Date tooltip',
    desc: TYPE_PARAGRAPH,
  },
  share_surveys_tooltip_heading: {
    id: 'PricingSummary.Feature.ShareSurveysTooltipHeading',
    defaultMessage: 'Share Surveys Heading',
    desc: TYPE_HEADER,
  },
  share_surveys_tooltip: {
    id: 'PricingSummary.Feature.ShareSurveysTooltip',
    defaultMessage: 'Share Surveys tooltip',
    desc: TYPE_PARAGRAPH,
  },
  share_with_your_organization_tooltip_heading: {
    id: 'PricingSummary.Feature.ShareWithYourOrganizationTooltipHeading',
    defaultMessage: 'Share With Your Organization Heading',
    desc: TYPE_HEADER,
  },
  share_with_your_organization_tooltip: {
    id: 'PricingSummary.Feature.ShareWithYourOrganizationTooltip',
    defaultMessage: 'Share With Your Organization tooltip',
    desc: TYPE_PARAGRAPH,
  },
  shared_group_library_tooltip_heading: {
    id: 'PricingSummary.Feature.SharedGroupLibraryTooltipHeading',
    defaultMessage: 'Shared Group Library Heading',
    desc: TYPE_HEADER,
  },
  shared_group_library_tooltip: {
    id: 'PricingSummary.Feature.SharedGroupLibraryTooltip',
    defaultMessage: 'Shared Group Library tooltip',
    desc: TYPE_PARAGRAPH,
  },
  shared_library_tooltip_heading: {
    id: 'PricingSummary.Feature.SharedLibraryTooltipHeading',
    defaultMessage: 'Shared Library Heading',
    desc: TYPE_HEADER,
  },
  shared_library_tooltip: {
    id: 'PricingSummary.Feature.SharedLibraryTooltip',
    defaultMessage: 'Shared Library tooltip',
    desc: TYPE_PARAGRAPH,
  },
  show_create_crosstab_tooltip_heading: {
    id: 'PricingSummary.Feature.ShowCreateCrosstabTooltipHeading',
    defaultMessage: 'Show Create Crosstab Heading',
    desc: TYPE_HEADER,
  },
  show_create_crosstab_tooltip: {
    id: 'PricingSummary.Feature.ShowCreateCrosstabTooltip',
    defaultMessage: 'Show Create Crosstab tooltip',
    desc: TYPE_PARAGRAPH,
  },
  show_create_header_upgrade_button_tooltip_heading: {
    id: 'PricingSummary.Feature.ShowCreateHeaderUpgradeButtonTooltipHeading',
    defaultMessage: 'Show Create Header Upgrade Button Heading',
    desc: TYPE_HEADER,
  },
  show_create_header_upgrade_button_tooltip: {
    id: 'PricingSummary.Feature.ShowCreateHeaderUpgradeButtonTooltip',
    defaultMessage: 'Show Create Header Upgrade Button tooltip',
    desc: TYPE_PARAGRAPH,
  },
  show_sig_diffs_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.ShowSigDiffsEnabledTooltipHeading',
    defaultMessage: 'Show Sig Diffs Enabled Heading',
    desc: TYPE_HEADER,
  },
  show_sig_diffs_enabled_tooltip: {
    id: 'PricingSummary.Feature.ShowSigDiffsEnabledTooltip',
    defaultMessage: 'Show Sig Diffs Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  single_sign_on_tooltip_heading: {
    id: 'PricingSummary.Feature.SingleSignOnTooltipHeading',
    defaultMessage: 'Single Sign On Heading',
    desc: TYPE_HEADER,
  },
  single_sign_on_tooltip: {
    id: 'PricingSummary.Feature.SingleSignOnTooltip',
    defaultMessage: 'Single Sign On tooltip',
    desc: TYPE_PARAGRAPH,
  },
  slider_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.SliderQuestionTypeTooltipHeading',
    defaultMessage: 'Slider Question Type Heading',
    desc: TYPE_HEADER,
  },
  slider_question_type_tooltip: {
    id: 'PricingSummary.Feature.SliderQuestionTypeTooltip',
    defaultMessage: 'Slider Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  smart_notifications_tooltip_heading: {
    id: 'PricingSummary.Feature.SmartNotificationsTooltipHeading',
    defaultMessage: 'Smart Notifications Heading',
    desc: TYPE_HEADER,
  },
  smart_notifications_tooltip: {
    id: 'PricingSummary.Feature.SmartNotificationsTooltip',
    defaultMessage: 'Smart Notifications tooltip',
    desc: TYPE_PARAGRAPH,
  },
  ssl_tls_encryption_tooltip_heading: {
    id: 'PricingSummary.Feature.SslTlsEncryptionTooltipHeading',
    defaultMessage: 'SSL/TLS Encryption Heading',
    desc: TYPE_HEADER,
  },
  ssl_tls_encryption_tooltip: {
    id: 'PricingSummary.Feature.SslTlsEncryptionTooltip',
    defaultMessage: 'SSL/TLS Encryption tooltip',
    desc: TYPE_PARAGRAPH,
  },
  star_rating_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.StarRatingQuestionTypeTooltipHeading',
    defaultMessage: 'Star Rating Question Type Heading',
    desc: TYPE_HEADER,
  },
  star_rating_question_type_tooltip: {
    id: 'PricingSummary.Feature.StarRatingQuestionTypeTooltip',
    defaultMessage: 'Star Rating Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  statistical_significance_tooltip_heading: {
    id: 'PricingSummary.Feature.StatisticalSignifcanceTooltipHeading',
    defaultMessage: 'ADVANCED SURVEY ANALYSIS',
    desc: TYPE_HEADER,
  },
  statistical_significance_tooltip: {
    id: 'PricingSummary.Feature.StatisticalSignifcanceTooltip',
    defaultMessage:
      'Get more context for your data. See if there are statistically significant differences between response groups. And use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.',
    desc: TYPE_PARAGRAPH,
  },
  survey_branding_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveyBrandingTooltipHeading',
    defaultMessage: 'CUSTOMIZED SURVEYS',
    desc: TYPE_HEADER,
  },
  survey_branding_tooltip: {
    id: 'PricingSummary.Feature.SurveyBrandingTooltip',
    defaultMessage: `Customize your survey's look and feel by adding your logo, selecting colors and web fonts, and uploading images. Create and save custom themes to quickly build on-brand surveys. You can also modify the ending of your survey's URL. For example: www.surveymonkey.com/s/your-survey`,
    desc: TYPE_PARAGRAPH,
  },
  survey_create_limit_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveyCreateLimitTooltipHeading',
    defaultMessage: 'NUMBER OF SURVEYS',
    desc: TYPE_HEADER,
  },
  survey_create_limit_tooltip: {
    id: 'PricingSummary.Feature.SurveyCreateLimitTooltip',
    defaultMessage: 'You can create and send as many surveys, polls, and quizzes as you need with any plan.',
    desc: TYPE_PARAGRAPH,
  },
  survey_templates_intl_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveyTemplatesIntlTooltipHeading',
    defaultMessage: 'Survey Templates Intl Heading',
    desc: TYPE_HEADER,
  },
  survey_templates_intl_tooltip: {
    id: 'PricingSummary.Feature.SurveyTemplatesIntlTooltip',
    defaultMessage: 'Survey Templates Intl tooltip',
    desc: TYPE_PARAGRAPH,
  },
  surveys_read_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveysReadTooltipHeading',
    defaultMessage: 'Surveys Read Heading',
    desc: TYPE_HEADER,
  },
  surveys_read_tooltip: {
    id: 'PricingSummary.Feature.SurveysReadTooltip',
    defaultMessage: 'Surveys Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  surveys_write_tooltip_heading: {
    id: 'PricingSummary.Feature.SurveysWriteTooltipHeading',
    defaultMessage: 'Surveys Write Heading',
    desc: TYPE_HEADER,
  },
  surveys_write_tooltip: {
    id: 'PricingSummary.Feature.SurveysWriteTooltip',
    defaultMessage: 'Surveys Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  team_ownership_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamOwnershipTooltipHeading',
    defaultMessage: 'Team Ownership Heading',
    desc: TYPE_HEADER,
  },
  team_ownership_tooltip: {
    id: 'PricingSummary.Feature.TeamOwnershipTooltip',
    defaultMessage: 'Team Ownership tooltip',
    desc: TYPE_PARAGRAPH,
  },
  team_themes_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamThemesTooltipHeading',
    defaultMessage: 'Team Themes Heading',
    desc: TYPE_HEADER,
  },
  team_themes_tooltip: {
    id: 'PricingSummary.Feature.TeamThemesTooltip',
    defaultMessage: 'Team Themes tooltip',
    desc: TYPE_PARAGRAPH,
  },
  teams_can_discover_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamsCanDiscoverTooltipHeading',
    defaultMessage: 'Teams Can Discover Heading',
    desc: TYPE_HEADER,
  },
  teams_can_discover_tooltip: {
    id: 'PricingSummary.Feature.TeamsCanDiscoverTooltip',
    defaultMessage: 'Teams Can Discover tooltip',
    desc: TYPE_PARAGRAPH,
  },
  teams_can_make_discoverable_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamsCanMakeDiscoverableTooltipHeading',
    defaultMessage: 'Teams Can Make Discoverable Heading',
    desc: TYPE_HEADER,
  },
  teams_can_make_discoverable_tooltip: {
    id: 'PricingSummary.Feature.TeamsCanMakeDiscoverableTooltip',
    defaultMessage: 'Teams Can Make Discoverable tooltip',
    desc: TYPE_PARAGRAPH,
  },
  teams_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.TeamsEnabledTooltipHeading',
    defaultMessage: 'Teams Enabled Heading',
    desc: TYPE_HEADER,
  },
  teams_enabled_tooltip: {
    id: 'PricingSummary.Feature.TeamsEnabledTooltip',
    defaultMessage: 'Teams Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  text_analysis_tooltip_heading: {
    id: 'PricingSummary.Feature.TextAnalysisTooltipHeading',
    defaultMessage: 'ADVANCED SURVEY ANALYSIS',
    desc: TYPE_HEADER,
  },
  text_analysis_tooltip: {
    id: 'PricingSummary.Feature.TextAnalysisTooltip',
    defaultMessage:
      'Get more context for your data. See if there are statistically significant differences between response groups. And use text analysis to search and categorize open-ended responses and quickly see frequently used words and phrases.',
    desc: TYPE_PARAGRAPH,
  },
  text_formatting_tooltip_heading: {
    id: 'PricingSummary.Feature.TextFormattingTooltipHeading',
    defaultMessage: 'Text Formatting Heading',
    desc: TYPE_HEADER,
  },
  text_formatting_tooltip: {
    id: 'PricingSummary.Feature.TextFormattingTooltip',
    defaultMessage: 'Text Formatting tooltip',
    desc: TYPE_PARAGRAPH,
  },
  textbox_multiple_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.TextboxMultipleQuestionTypeTooltipHeading',
    defaultMessage: 'Textbox Multiple Question Type Heading',
    desc: TYPE_HEADER,
  },
  textbox_multiple_question_type_tooltip: {
    id: 'PricingSummary.Feature.TextboxMultipleQuestionTypeTooltip',
    defaultMessage: 'Textbox Multiple Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  track_email_responses_tooltip_heading: {
    id: 'PricingSummary.Feature.TrackEmailResponsesTooltipHeading',
    defaultMessage: 'Track Email Responses Heading',
    desc: TYPE_HEADER,
  },
  track_email_responses_tooltip: {
    id: 'PricingSummary.Feature.TrackEmailResponsesTooltip',
    defaultMessage: 'Track Email Responses tooltip',
    desc: TYPE_PARAGRAPH,
  },
  try_before_you_buy_enabled_tooltip_heading: {
    id: 'PricingSummary.Feature.TryBeforeYouBuyEnabledTooltipHeading',
    defaultMessage: 'Try Before You Buy Enabled Heading',
    desc: TYPE_HEADER,
  },
  try_before_you_buy_enabled_tooltip: {
    id: 'PricingSummary.Feature.TryBeforeYouBuyEnabledTooltip',
    defaultMessage: 'Try Before You Buy Enabled tooltip',
    desc: TYPE_PARAGRAPH,
  },
  unlimited_responses_tooltip_heading: {
    id: 'PricingSummary.Feature.UnlimitedResponsesTooltipHeading',
    defaultMessage: NUM_RESPONSES,
    desc: TYPE_HEADER,
  },
  unlimited_responses_tooltip: {
    id: 'PricingSummary.Feature.UnlimitedResponsesTooltip',
    defaultMessage: NUM_RESPONSES_TOOLTIP,
    desc: TYPE_PARAGRAPH,
  },
  user_management_tooltip_heading: {
    id: 'PricingSummary.Feature.UserManagmentTooltipHeading',
    defaultMessage: 'User Management Heading',
    desc: TYPE_HEADER,
  },
  user_management_tooltip: {
    id: 'PricingSummary.Feature.UserManagmentTooltip',
    defaultMessage: 'User Management tooltip',
    desc: TYPE_PARAGRAPH,
  },
  users_read_tooltip_heading: {
    id: 'PricingSummary.Feature.UsersReadTooltipHeading',
    defaultMessage: 'Users Read Heading',
    desc: TYPE_HEADER,
  },
  users_read_tooltip: {
    id: 'PricingSummary.Feature.UsersReadTooltip',
    defaultMessage: 'Users Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  validate_answer_tooltip_heading: {
    id: 'PricingSummary.Feature.ValidateAnswerTooltipHeading',
    defaultMessage: 'Validate Answer Heading',
    desc: TYPE_HEADER,
  },
  validate_answer_tooltip: {
    id: 'PricingSummary.Feature.ValidateAnswerTooltip',
    defaultMessage: 'Validate Answer tooltip',
    desc: TYPE_PARAGRAPH,
  },
  video_question_type_tooltip_heading: {
    id: 'PricingSummary.Feature.VideoQuestionTypeTooltipHeading',
    defaultMessage: 'Video Question Type Heading',
    desc: TYPE_HEADER,
  },
  video_question_type_tooltip: {
    id: 'PricingSummary.Feature.VideoQuestionTypeTooltip',
    defaultMessage: 'Video Question Type tooltip',
    desc: TYPE_PARAGRAPH,
  },
  view_respondent_ip_address_tooltip_heading: {
    id: 'PricingSummary.Feature.ViewRespondentIpAddrressTooltipHeading',
    defaultMessage: 'View Responded Ip Address Heading',
    desc: TYPE_HEADER,
  },
  view_respondent_ip_address_tooltip: {
    id: 'PricingSummary.Feature.ViewRespondentIpAddrressTooltip',
    defaultMessage: 'View Responded Ip Address tooltip',
    desc: TYPE_PARAGRAPH,
  },
  webhooks_read_tooltip_heading: {
    id: 'PricingSummary.Feature.WebhooksReadTooltipHeading',
    defaultMessage: 'Webhooks Read Heading',
    desc: TYPE_HEADER,
  },
  webhooks_read_tooltip: {
    id: 'PricingSummary.Feature.WebhooksReadTooltip',
    defaultMessage: 'Webhooks Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  webhooks_write_tooltip_heading: {
    id: 'PricingSummary.Feature.WebhooksWriteTooltipHeading',
    defaultMessage: 'Webhooks Write Heading',
    desc: TYPE_HEADER,
  },
  webhooks_write_tooltip: {
    id: 'PricingSummary.Feature.WebhooksWriteTooltip',
    defaultMessage: 'Webhooks Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_members_read_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsMembersReadTooltipHeading',
    defaultMessage: 'Workgroups Members Read Heading',
    desc: TYPE_HEADER,
  },
  workgroups_members_read_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsMembersReadTooltip',
    defaultMessage: 'Workgroups Members Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_members_write_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsMembersWriteTooltipHeading',
    defaultMessage: 'Workgroups Members Write Heading',
    desc: TYPE_HEADER,
  },
  workgroups_members_write_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsMembersWriteTooltip',
    defaultMessage: 'Workgroups Members Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_read_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsReadTooltipHeading',
    defaultMessage: 'Workgroups Read Heading',
    desc: TYPE_HEADER,
  },
  workgroups_read_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsReadTooltip',
    defaultMessage: 'Workgroups Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_shares_read_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsSharesReadTooltipHeading',
    defaultMessage: 'Workgroups Shares Read Heading',
    desc: TYPE_HEADER,
  },
  workgroups_shares_read_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsSharesReadTooltip',
    defaultMessage: 'Workgroups Shares Read tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_shares_write_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsSharesWriteTooltipHeading',
    defaultMessage: 'Workgroups Shares Write Heading',
    desc: TYPE_HEADER,
  },
  workgroups_shares_write_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsSharesWriteTooltip',
    defaultMessage: 'Workgroups Shares Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
  workgroups_write_tooltip_heading: {
    id: 'PricingSummary.Feature.WorkgroupsWriteTooltipHeading',
    defaultMessage: 'Workgroups Write Heading',
    desc: TYPE_HEADER,
  },
  workgroups_write_tooltip: {
    id: 'PricingSummary.Feature.WorkgroupsWriteTooltip',
    defaultMessage: 'Workgroups Write tooltip',
    desc: TYPE_PARAGRAPH,
  },
});
